import { Component, Input } from '@angular/core';

/** Default diameter (px) — matches the legacy app's Google-style loading spinner. */
const DEFAULT_LOADER_SIZE_PX = 64;

/**
 * Single, application-wide loading indicator.
 *
 * This is the ONLY loader component in the application — every screen and
 * feature module must use `app-loading-spinner` instead of introducing a
 * bespoke spinner/overlay, to keep the loading experience visually
 * consistent (round, red, animated circle). The rotate + dash animation
 * mirrors the legacy app's spinner (see legacy `loader.css`), rendered in
 * a single red stroke instead of the legacy's multi-color cycle.
 */
@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  @Input() label = '';
  @Input() centered = false;
  @Input() size = DEFAULT_LOADER_SIZE_PX;
}
